webpackJsonp([217492442663653],{

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(46);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Merken = function Merken(props) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactHelmet2.default, {
	            title: 'Algemene Voorwaarden | Gifture'
	        }),
	        _react2.default.createElement(
	            'div',
	            { className: 'hero is-primary' },
	            _react2.default.createElement(
	                'div',
	                { className: 'hero-body' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container has-text-centered' },
	                    _react2.default.createElement(
	                        'h1',
	                        { className: 'title' },
	                        'Producten, diensten en merken van Gifture Concepts'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'section' },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'columns' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'column' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'content' },
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Gifture Photobooth is onderdeel van Gifture Concepts. ',
	                                _react2.default.createElement('br', null),
	                                'Naast de photobooth verhuur hebben wij meerdere niche-webshops, waaronder:'
	                            ),
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'KabelBeestjes.nl'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'De nieuwste rage in Nederland is te koop bij ',
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'https://www.kabelbeestjes.nl/alle-kabelbeestjes', title: 'Verkoop Cable Munchers / Cable Bites / Kabel Beestjes in Nederland' },
	                                    'Kabel Beestjes.'
	                                ),
	                                _react2.default.createElement('br', null),
	                                'Kabel Beestjes (ookwel ',
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'https://www.kabelbeestjes.nl/alle-cable-munchers', title: 'Cable Munchers kopen (Nederland)' },
	                                    'Cable Munchers'
	                                ),
	                                ' of ',
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'https://www.kabelbeestjes.nl/alle-cable-bites', title: 'Cable Bites kopen (Nederland)' },
	                                    'Cable Bites'
	                                ),
	                                ' genoemd) zijn schattige diertjes die je op je oplaadkabel kunt klikken. ',
	                                _react2.default.createElement('br', null),
	                                'Naast dat ze er super schattig uit zien, zijn het ook nog eens hele handige ',
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'https://www.kabelbeestjes.nl', title: 'Kabelbeschermer kopen (Nederland)' },
	                                    'oplaadkabel beschermers'
	                                ),
	                                '.'
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Merken;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-gifture-merken-js-92c533100ce535c65dc7.js